import {
  Drawer,
  DrawerContent,
  DrawerContentProps,
  DrawerOverlay,
} from "@chakra-ui/react";

interface Props {
  isOpen: boolean;
  onClose?: () => void;
  contentProps?: DrawerContentProps;
}

export const DrawerSidebar: React.FC<Props> = ({
  isOpen,
  contentProps,
  onClose = () => {},
  children,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      placement="left"
      onClose={onClose}
      size="full"
      useInert
      preserveScrollBarGap
    >
      <DrawerOverlay />
      <DrawerContent bgColor="gray.600" overflowY="auto" {...contentProps}>
        {children}
      </DrawerContent>
    </Drawer>
  );
};
